<template>
  <div>
    <b-card>
        <h5  class="mt-3 mb-4 text-left institution-title">{{user.institution.name}}</h5>
      <b-row>
        <statistic-number :institution="user.institution"></statistic-number>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import StatisticNumber from '@/components/dashboard/StatisticNumber'
import institution from "@/store/modules/institution/institution";
import {USER_DATA} from "@/shared/constants";
export default {
    name: 'Index',
    components: {
       StatisticNumber
    },
    computed: {
      user(){
        return JSON.parse(localStorage.getItem(USER_DATA))
      }
    },

}
</script>
<style scoped>
   .logo {
     max-width: 350px;
     max-height: 100px
   }
   .institution-title{
     color:#636564;
   }
</style>
